import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class WiFiFrequencyEnumConverter implements JsonCustomConvert<WiFiFrequencyEnum> {
  serialize() {}

  deserialize(data: any): WiFiFrequencyEnum {
    switch (data) {
      case 'FREQ_2_4_GHZ':
        return WiFiFrequencyEnum.FREQ_2_4_GHZ;
      case 'FREQ_5_GHZ':
        return WiFiFrequencyEnum.FREQ_5_GHZ;
      case 'FREQ_6_GHZ':
        return WiFiFrequencyEnum.FREQ_6_GHZ;
      default:
        return WiFiFrequencyEnum.FREQ_2_4_GHZ;
    }
  }
}

export enum WiFiFrequencyEnum {
  FREQ_2_4_GHZ = 'FREQ_2_4_GHZ',
  FREQ_5_GHZ = 'FREQ_5_GHZ',
  FREQ_6_GHZ = 'FREQ_6_GHZ',
}
